import { api } from "./api.service";

export class ProgressService {
  static async getProgressData(
    showQuarterlyRecords = false,
    showMonthlyRecords = false,
    showWeeklyRecords = false,
    dayChart = false,
    weekChart = false,
    monthChart = false
  ) {
    const params = {};

    if (showQuarterlyRecords) {
      params["showQuarterlyRecords"] = showQuarterlyRecords;
    }
    if (showMonthlyRecords) {
      params["showMonthlyRecords"] = showMonthlyRecords;
    }
    if (showWeeklyRecords) {
      params["showWeeklyRecords"] = showWeeklyRecords;
      console.log("rinasdksadaoksd");
    }
    if (dayChart) {
      params["dayChart"] = dayChart;
    }
    if (weekChart) {
      params["weekChart"] = weekChart;
    }
    if (monthChart) {
      params["monthChart"] = monthChart;
    }

    return api.get("points", { params });
  }
}
